import { render, staticRenderFns } from "./poem.vue?vue&type=template&id=199ad25e&"
import script from "./poem.vue?vue&type=script&lang=js&"
export * from "./poem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports